import * as React from "react"
import {Box} from "@mui/material";
import {ImageSeeker, ModalSeeker} from "@ui-seeker/core";
import {isEmpty} from "@ui-seeker/utils";
import {BACKEND_APIS} from "@constants";
import {imageModalData} from "@signals";


export default function AppImageModal() {
    const isOpen = !isEmpty(imageModalData.value)
    const src = imageModalData.value?.fullSRC || `${BACKEND_APIS.BACKEND}/sku/image-resource?url=${imageModalData.value.src}`
    
    return (
        <ModalSeeker 
            hideActions 
            isOpen={isOpen} 
            title={imageModalData.value?.title || 'Imagen'} 
            controller={() => imageModalData.value = {}}
            containerProps={{ fullScreen: true }}
        >
            <Box
                maxWidth={1}
                mx="auto"
                p={2}
                height="85vh"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Box
                    flex={1}
                    border='1px solid'
                    borderColor='divider'
                    borderRadius={1}
                    p={1}
                    display="flex"
                    flexDirection="column"
                    height="100%"
                    overflow="auto"
                    bgcolor='background.default'
                >
                    <Box 
                        sx={{ 
                            width: '100%',
                            minHeight: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            '&:hover .zoomable': {
                                transform: 'scale(1.05)',
                            },
                        }}
                    >
                        {/* Eager + spinner: the modal shows one picture, there is nothing to lazy-load, and
                            ImageSeeker's lazy mode (the default) waits for an IntersectionObserver on an empty
                            0x0 placeholder inside the sliding Dialog, which intermittently never fires and left
                            the modal blank (869fkkvf0). `lazyLoad` and `useSpinner` must not be combined
                            (see MatchersLazyImage). */}
                        <ImageSeeker
                            lazyLoad={false}
                            useSpinner
                            src={src}
                            sx={{
                                maxWidth: '100%',
                                maxHeight: 'none',
                                objectFit: 'contain',
                                transition: 'transform .2s ease',
                                willChange: 'transform',
                                cursor: 'zoom-in',
                            }}
                            className="zoomable"
                        />
                    </Box>
                </Box>
            </Box>
        </ModalSeeker>
    )
}